import {Link as MuiLink, LinkProps as MuiLinkProps} from '@mui/material';
import {ElementType} from 'react';
import {ComponentReturnValue, PropsWithRequiredChildren} from '../react/types';

type AllowedMuiLinkProps<E extends ElementType> = Omit<MuiLinkProps<E>, 'children'>;
export type LinkProps<E extends ElementType = 'a'> = PropsWithRequiredChildren<AllowedMuiLinkProps<E>>;

export const Link: <E extends ElementType>(props: PropsWithRequiredChildren<LinkProps<E>>) => ComponentReturnValue = ({
  children,
  color = 'primary',
  sx,
  underline = 'hover',
  variant = 'inherit',
  ...muiProps
}: LinkProps) => {
  return (
    <MuiLink color={color} sx={{fontWeight: 'bolder', ...sx}} underline={underline} variant={variant} {...muiProps}>
      {children}
    </MuiLink>
  );
};
